import { useState } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d75697r41deorl02f5h0';

const NewsletterSection = () => {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email || !name) return;
    setStatus('loading');

    try {
      const body = new URLSearchParams({ name, email });
      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setStatus('success');
        setEmail('');
        setName('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="relative py-28 overflow-hidden">
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/dfda8fef5ad0ead4d97d46031eb9ee91.jpg')`,
        }}
      />
      <div className="absolute inset-0 bg-stone-900/70" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Label */}
        <span className="inline-block text-xs uppercase tracking-widest font-semibold mb-4 px-4 py-1.5 rounded-full border" style={{ color: '#8aab8a', borderColor: '#8aab8a55' }}>
          Wellness Newsletter
        </span>

        {/* Heading */}
        <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
          Begin Your Journey<br />
          <span className="italic font-normal" style={{ color: '#a8c5a8' }}>Before You Arrive</span>
        </h2>

        <p className="text-stone-300 text-base md:text-lg leading-relaxed mb-10 max-w-xl mx-auto">
          Subscribe for Ayurvedic wisdom, retreat updates, seasonal wellness tips, and early access to our upcoming programs in Fuerteventura.
        </p>

        {status === 'success' ? (
          <div className="flex flex-col items-center gap-4">
            <div className="w-16 h-16 flex items-center justify-center rounded-full" style={{ backgroundColor: '#8aab8a22', border: '1px solid #8aab8a' }}>
              <i className="ri-check-line text-3xl" style={{ color: '#8aab8a' }}></i>
            </div>
            <p className="text-white text-lg font-serif font-medium">You\'re in! Welcome to the Swasthya family.</p>
            <p className="text-stone-400 text-sm">Check your inbox for a warm welcome from us.</p>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form
            className="flex flex-col sm:flex-row gap-3 max-w-2xl mx-auto"
          >
            <input
              type="text"
              name="name"
              value={name}
              onChange={e => setName(e.target.value)}
              placeholder="Your first name"
              required
              className="flex-1 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-5 py-3.5 text-white placeholder-stone-400 text-sm focus:outline-none focus:border-white/50 transition-colors"
            />
            <input
              type="email"
              name="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Your email address"
              required
              className="flex-1 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-5 py-3.5 text-white placeholder-stone-400 text-sm focus:outline-none focus:border-white/50 transition-colors"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="rounded-full px-8 py-3.5 text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap disabled:opacity-60"
              style={{ backgroundColor: '#8aab8a', color: '#1a1a1a' }}
              onMouseEnter={e => !e.currentTarget.disabled && (e.currentTarget.style.backgroundColor = '#7a9b7a')}
              onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#8aab8a')}
            >
              {status === 'loading' ? (
                <span className="flex items-center gap-2">
                  <i className="ri-loader-4-line animate-spin"></i> Subscribing…
                </span>
              ) : (
                'Subscribe'
              )}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="mt-4 text-red-400 text-sm">Something went wrong. Please try again.</p>
        )}

        <p className="mt-6 text-stone-500 text-xs">
          No spam, ever. Unsubscribe anytime. Read our{' '}
          <a href="/privacy-policy" className="underline underline-offset-2 hover:text-stone-300 transition-colors cursor-pointer" style={{ color: '#8aab8a' }}>
            Privacy Policy
          </a>
          .
        </p>
      </div>
    </section>
  );
};

export default NewsletterSection;
